import React from 'react';
import { Modal, Container, Row, Col, ListGroup, Card } from 'react-bootstrap';

const WaterproofingDetails = ({ show, onHide }) => {
  return (
    <Modal show={show} onHide={onHide} size="xl" centered scrollable className="service-details-modal">
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="fw-bold display-6">
          Apex <span className="text-primary">Advanced</span> Waterproofing
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-4">
        <Container>
          {/* Hero Section of Modal */}
          <div className="modal-service-hero rounded-4 mb-5 overflow-hidden position-relative" style={{ height: '300px' }}>
            <div 
              className="w-100 h-100" 
              style={{ 
                backgroundImage: "url('/water_proofing.png')", 
                backgroundSize: 'cover', 
                backgroundPosition: 'center' 
              }}
            ></div>
            <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex align-items-center p-5">
              <div className="text-white">
                <h2 className="fw-bold mb-3">Engineered for Permanence</h2>
                <p className="lead mb-0">At Apex Enterprises, we don't just stop leaks—we engineer long-term barrier solutions using world-class technologies.</p>
              </div>
            </div>
          </div>

          <Row className="g-4">
            <Col lg={7}>
              <h3 className="fw-bold mb-4">Our Systematic Approach</h3>
              <div className="process-timeline">
                <div className="process-step mb-4 d-flex">
                  <div className="step-number bg-primary text-white rounded-circle me-3 flex-shrink-0">1</div>
                  <div>
                    <h5 className="fw-bold">Scientific Diagnosis</h5>
                    <p className="text-muted">We begin with a thorough moisture analysis and thermal imaging to identify hidden leakage sources and structural vulnerabilities.</p>
                  </div>
                </div>
                <div className="process-step mb-4 d-flex">
                  <div className="step-number bg-primary text-white rounded-circle me-3 flex-shrink-0">2</div>
                  <div>
                    <h5 className="fw-bold">Substrate Preparation</h5>
                    <p className="text-muted">Surface is mechanically cleaned, cracks are V-grooved and filled with specialized micro-concrete or polymer-modified mortars.</p>
                  </div>
                </div>
                <div className="process-step mb-4 d-flex">
                  <div className="step-number bg-primary text-white rounded-circle me-3 flex-shrink-0">3</div>
                  <div>
                    <h5 className="fw-bold">Multi-Layer Application</h5>
                    <p className="text-muted">Application of primer followed by multiple coats of advanced membranes (PU, Acrylic, or Crystalline) reinforced with fiber mesh at critical junctions.</p>
                  </div>
                </div>
                <div className="process-step mb-0 d-flex">
                  <div className="step-number bg-primary text-white rounded-circle me-3 flex-shrink-0">4</div>
                  <div>
                    <h5 className="fw-bold">Flood Testing & QC</h5>
                    <p className="text-muted">A mandatory 48-hour flood test is conducted to ensure 100% integrity before final protection layers are applied.</p>
                  </div>
                </div>
              </div>
            </Col>
            <Col lg={5}>
              <Card className="border-0 bg-light rounded-4 p-4 shadow-sm mb-4">
                <h4 className="fw-bold mb-3 text-primary">Key Technologies</h4>
                <ListGroup variant="flush" className="bg-transparent">
                  <ListGroup.Item className="bg-transparent border-0 px-0 d-flex align-items-center">
                    <i className="fas fa-shield-virus text-primary me-2"></i>
                    <strong>Nano-Crystalline:</strong> Penetrates deep into concrete pores.
                  </ListGroup.Item>
                  <ListGroup.Item className="bg-transparent border-0 px-0 d-flex align-items-center">
                    <i className="fas fa-layer-group text-primary me-2"></i>
                    <strong>TPO Membranes:</strong> High-performance thermoplastic solutions.
                  </ListGroup.Item>
                  <ListGroup.Item className="bg-transparent border-0 px-0 d-flex align-items-center">
                    <i className="fas fa-vial text-primary me-2"></i>
                    <strong>Polyurea Coatings:</strong> Instant-curing, heavy-duty protection.
                  </ListGroup.Item>
                  <ListGroup.Item className="bg-transparent border-0 px-0 d-flex align-items-center">
                    <i className="fas fa-fill-drip text-primary me-2"></i>
                    <strong>Epoxy Injection:</strong> Structural crack healing.
                  </ListGroup.Item>
                </ListGroup>
              </Card>

              <Card className="border-0 bg-primary text-white rounded-4 p-4 shadow-lg">
                <h4 className="fw-bold mb-3">Why Apex?</h4>
                <div className="d-flex mb-3 align-items-start">
                  <i className="fas fa-certificate mt-1 me-3"></i>
                  <div>
                    <h6 className="mb-1 fw-bold">Certified Expertise</h6>
                    <p className="small mb-0 opacity-75">Trained by industry leaders like Dr. Fixit & BASF.</p>
                  </div>
                </div>
                <div className="d-flex align-items-start">
                  <i className="fas fa-history mt-1 me-3"></i>
                  <div>
                    <h6 className="mb-1 fw-bold">Longevity</h6>
                    <p className="small mb-0 opacity-75">Our solutions are designed to last for the lifetime of the structure.</p>
                  </div>
                </div>
              </Card>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
    </Modal>
  );
};

export default WaterproofingDetails;